import { render, staticRenderFns } from "./NewSkuCard.vue?vue&type=template&id=5bc83284&"
import script from "./NewSkuCard.vue?vue&type=script&lang=js&"
export * from "./NewSkuCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports